<template>
    <section style="margin: 18px;">
        <v-layout>
            <v-layout xs4 style="margin: 0px 24px;padding-top: 6px;border-right: 1px solid lightgrey;" row>
                <v-text-field label="Search User" @change="SearchUserAPI" v-model="SearchUser"></v-text-field>
                <v-flex>
                    <v-menu v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="From_Date"
                                            label="Pick From Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="From_Date" @input="menu1 = false"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex>
                     <v-menu v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="To_Date"
                                        label="Pick To date"
                                        prepend-icon="event"
                                        clearable
                                        readonly
                                        v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="To_Date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-btn icon style="margin: 0px 14px;margin-top: 13px;">
                    <v-icon @click="SearchNow">search</v-icon>
                </v-btn>
            </v-layout>
            <v-layout xs4 style="margin-top: 14px;" row>
                <v-btn :disabled='!Users.length > 0' @click="CSVExport">Export</v-btn>
            </v-layout>
        </v-layout>
        <v-data-table :headers="headers" 
                      :items="Users" 
                      hide-actions
                      style="margin-bottom: 10px;"
                        class="elevation-1" 
                        disable-initial-sort>
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Email }}</td>
                    <td class="text-xs-center">{{ props.item.Phone_Number }}</td>
                    <td class="text-xs-center">{{ props.item.Name }}</td>
                    <td class="text-xs-center">{{ props.item.Qualification }}</td>
                    <td class="text-xs-center">{{ props.item.Address }}</td>
                    <td class="text-xs-center">{{ props.item.Referal_Code }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUserCourseModal(props.item)">
                            <v-icon>assignment_turned_in</v-icon>
                        </v-btn>
                    </td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUpdateUserModal(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                   <v-flex>Update User Details</v-flex>
                   <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Email" label='Email'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Phone_Number" label='Phone Number'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Name" label='Name'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Qualification" label='Qualification'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Address" label='Address'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="CurrentUser.Referal_Code" label='Referal Code'></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-checkbox v-model="CurrentUser.Disable" :label="`${ CurrentUser.Disable ? 'User Disabled' : 'User Not Disabled'}`" class="mx-2"></v-checkbox>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" @click="UpdateUserDetails">Update User Details</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="CourseDialog" persistent max-width="800px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                   <v-flex>Courses</v-flex>
                   <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-flex  style="font-weight: 600;">Assign Course :</v-flex>
                        <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourse" :items="GetCourseDetailList" label="Select Course Title" @change="OnCourseSelected">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Course_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Course_Title }}    
                            </template>
                        </v-select>
                        <v-flex v-if="Object.keys(SelectedCourse).length > 0 && SelectedCourse['Course_Types'] && SelectedCourse['Course_Types'].length > 0">
                            <v-radio-group v-model="SelectCheckBox" row @change="GetSchedule">
                                <v-radio v-for="n in SelectedCourse['Course_Types']" :key="n" :label="CourseTypeLabel(n)" :value="n"></v-radio>
                            </v-radio-group>
                            <v-flex v-if="SelectCheckBox && CourseTypeRequiresBatch(SelectCheckBox)" style="color:#616161;padding:4px 0 8px;">
                                {{ AvailableSchedules.length ? 'Select an existing batch.' : 'No batch on this course. Add one under Add Schedule.' }}
                            </v-flex>
                            <v-flex v-if="SelectCheckBox && CourseTypeRequiresBatch(SelectCheckBox) && AvailableSchedules.length > 0">
                                <v-select item-value='_id' item-text='name' return-object v-model="SelectedSchedule" :items="AvailableSchedules" label="Select Schedule">
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ new Date(item.Schedule_Start_Date).toDateString() }} , {{ item.Schedule_Time}}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ new Date(item.Schedule_Start_Date).toDateString() }} , {{ item.Schedule_Time}} 
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-text-field v-model="Price" type="number" label="Amount Recieved" ></v-text-field>
                            <v-flex>
                                <v-btn color='primary' @click="AssignCourse">Assign Course</v-btn>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-flex v-if="MyCourseList.length > 0" style="padding-top: 15px;">
                        <v-flex style="font-weight: 600;">User Course List :</v-flex>
                        <v-flex v-for="item in MyCourseList" :key="item._id" class="clsforCourses">
                            <img style="height: 150px;width: 200px;" :src="item.Course_Image"/>
                            <v-flex style="font-weight: 900;">{{ item.Course_Title }}</v-flex>
                            <v-flex style="font-weight: 900;">Course Type : {{ CourseTypeLabel(item.Course_Type) }}</v-flex>
                            <v-flex v-if="item.Course_Type != 'Online'">
                                Schedule On {{ item.Schedules && item.Schedules[0] && item.Schedules[0]['Schedule_Start_Date'] ? new Date(item.Schedules[0]['Schedule_Start_Date']).toDateString() : '' }} , {{  item.Schedules && item.Schedules[0] && item.Schedules[0]['Schedule_Time'] ? item.Schedules[0]['Schedule_Time'] : '' }}
                            </v-flex>
                            <v-switch v-model="item.CanAccess" @change="SetCourseAccess(item, $event)" :label="`Course ${ item.CanAccess ? 'Can Be Accessed By User' : 'Cannot Be Accessed By User'}`"></v-switch>
                        </v-flex>
                    </v-flex>
                    <v-flex v-else style="text-align: center;padding-top: 15px;">
                        No Subscribed Course
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
import { CourseTypeLabel, CourseTypeRequiresBatch, BatchSelectMessage, CourseIdOf, MatchesScheduleType, SchedulesForCourseType } from '../util/courseTypes'
export default {
    data(){
        return {
            Users   : [],
            headers : [ { text: 'Email',value: 'Email' },
			{ text: 'Phone Number', value: 'Phone_Number' },
                        { text: 'Name' ,value: 'Name'},
                        { text: 'Qualification' ,value: 'Qualification'},
                        { text: 'Address' ,value: 'Address'},
                        { text: 'Referal Code' ,value: 'Referal_Code'},
                        { text: 'Courses' },
                        { text: 'Actions' } ],
            pages       : 1,
            records     : 0,
            dialog      : false,
            CurrentUser : {},
            From_Date  : null,
            To_Date    : null,
            menu1      : false,
            menu2      : false,
            SearchUser : "",
            CourseDialog   : false,
            MyCourseList   : [],
            SelectedCourse : {},
            SelectCheckBox : "",
            checkbox       : false,
            Schedules      : [],
            CourseSchedules  : [],
            SelectedSchedule : {},
            Price            : 0,
        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList || []
        },
        AvailableSchedules(){
            const type = this.SelectCheckBox
            if (!type || type === 'Online') return []
            return SchedulesForCourseType(this.CourseSchedules.length ? this.CourseSchedules : this.Schedules, type)
        }
    },
    methods:{
        SetCourseAccess(MyCourse, enabled){
            const canAccess = typeof enabled === 'boolean' ? enabled : !!MyCourse.CanAccess
            MyCourse.CanAccess = canAccess
            MyCourse.Disabled = !canAccess
            let data = { "MyCourse_Id": MyCourse['_id'] , "Status" : MyCourse.Disabled }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/mycourses/changecourseaccess`,data)
                        .then(response => {
                            this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Changes Course Status Successfully",Color: "green",Close: false});
                        })
                        .catch(err => {
                            MyCourse.CanAccess = !canAccess
                            MyCourse.Disabled = canAccess
                            this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                        });

        },
        ResetAssignSelection(){
            this.SelectCheckBox = ""
            this.Schedules = []
            this.CourseSchedules = []
            this.SelectedSchedule = {}
        },
        OnCourseSelected(){
            this.SelectCheckBox = ""
            this.SelectedSchedule = {}
            this.LoadCourseSchedules(this.SelectedCourse)
        },
        CourseIdOf,
        CourseTypeLabel,
        CourseTypeRequiresBatch,
        BatchSelectMessage,
        MatchesScheduleType,
        LoadCourseSchedules(course){
            if (!course || !course._id) {
                this.CourseSchedules = []
                this.Schedules = []
                return
            }
            const embedded = course.Schedules || []
            this.CourseSchedules = embedded
            this.Schedules = embedded
            this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/getschedules`)
                .then(response => {
                    const all = response['data']['response'] || []
                    const courseId = String(course._id)
                    const matched = all.filter(s => this.CourseIdOf(s) === courseId)
                    if (matched.length) {
                        this.CourseSchedules = matched
                        this.Schedules = matched
                    }
                    if (this.SelectCheckBox) this.GetSchedule(this.SelectCheckBox)
                })
                .catch(() => {
                    if (!this.CourseSchedules.length) {
                        this.CourseSchedules = []
                        this.Schedules = []
                    }
                })
        },
        GetSchedule(Select){
            const type = Select || this.SelectCheckBox
            this.SelectedSchedule = {}
            this.Schedules = type != 'Online' ? SchedulesForCourseType(this.CourseSchedules.length ? this.CourseSchedules : (this.SelectedCourse['Schedules'] || []), type) : []
            if (this.AvailableSchedules.length === 1) this.SelectedSchedule = this.AvailableSchedules[0]
       },
        AssignCourse(){
            let data = {
                "User_Id"   : this.CurrentUser['_id'],
                'Items'       : [
                    { 
                        'Course_Id'     : this.SelectedCourse['_id'],
                        'Course_Type'   : this.SelectCheckBox,
                        'Purchase_Type' : 'Course',
                        'Actual_Amount' : 0,
                        'Discounted_Amount'   : parseInt(this.Price)
                    }
                ]
            }
            if (this.SelectCheckBox != 'Online' && this.SelectedSchedule && this.SelectedSchedule['_id']) {
                data['Items'][0]['Schedule_Id'] = this.SelectedSchedule['_id']
            }
            if (CourseTypeRequiresBatch(this.SelectCheckBox) && !data['Items'][0]['Schedule_Id'] && this.AvailableSchedules.length === 1) {
                this.SelectedSchedule = this.AvailableSchedules[0]
                data['Items'][0]['Schedule_Id'] = this.SelectedSchedule['_id']
            }
            if (CourseTypeRequiresBatch(this.SelectCheckBox) && !data['Items'][0]['Schedule_Id']) {
                const extra = this.AvailableSchedules.length ? BatchSelectMessage(this.SelectCheckBox) : 'No batch on this course. Add one under Add Schedule.'
                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: extra, Color: "red", Close: false});
                return
            }
            const Schedule = this.SelectCheckBox === 'Online' || data['Items'][0]['Schedule_Id']
            if(this.SelectedCourse && Object.keys(this.SelectedCourse).length > 0 && this.SelectCheckBox && Schedule && this.Price >= 0){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/mycourses/assigncoursetouser`,data)
                        .then(response => {
                            if (response['data'] && response['data']['Status'] === false) {
                                this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: response['data']['message'] || response['data']['error'] || "Could not assign course",Color: "red",Close: false});
                                return
                            }
                            this.CloseDialog()
                            this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Course Assigned Successfully",Color: "green",Close: false});
                        })
                        .catch(err => {
                            this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                        });
            }else{
                this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Select All Details",Color: "red",Close: false});
            }
        },
        SearchUserAPI(){
            
            let data = { "Email": this.SearchUser }
            if(this.SearchUser.length > 5){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/searchusers`,data)
                    .then(response => {
                        
                        this.Users = response['data']['response']
                        this.records = response['data']['response'].length
                        this.$eventHub.$emit("LOADING",'false')
                    })
                    .catch(err => {
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });
            }else{
                this.GetNextSetOfData({ 'limit' : 10, 'page' : this.pages })
            }

        },
        GetNextSetOfData(data){


            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/getuserprofiles`,data)
                .then(response => {
                    
                    this.Users = response['data']['response']
                    this.records = response['data']['Records']
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });
        },
        CSVExport(){
            
            let data = { 'From_Date' : this.From_Date ? new Date(this.From_Date).setHours(0,0,0,0) : null ,
                         'To_Date'   : this.To_Date ? new Date(this.To_Date).setHours(23,59,59,59) : null }

            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/exportuserprofiles`,data)
                .then(response => {
                    
                   if(response && response['data'] && response['data']['response']){
    
                        let FileName = Object.keys(data).length > 0 ? Object.values(data).join('_') : "Complete"
                        let csvContent = "data:text/csv;charset=utf-8,";
                        csvContent += response['data']['response']
                        const CSV_data = encodeURI(csvContent);
                        const link = document.createElement("a");
                        link.setAttribute("href", CSV_data);
                        link.setAttribute("download", `Users_${FileName}.csv`);
                        link.click();

                    }else{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Downloading","Color":"red","Close": false });
                    }
        
                })
                .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });

        },
        SearchNow(){
            this.GetNextSetOfData({ 
                    'limit' : 10, 
                    'page' : this.pages ,
                    'From_Date' : this.From_Date ? new Date(this.From_Date).setHours(0,0,0,0) : "" ,
                    'To_Date'   : this.To_Date ? new Date(this.To_Date).setHours(23,59,59,59) : "" })
        },
        OpenUpdateUserModal(User){
            this.dialog = true
            this.CurrentUser = User
        },
        OpenUserCourseModal(User){

            let data = { "User_Id" : User['_id'] }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/mycourses/getusercourses`,data)
                    .then(response => {
                        
                        this.CourseDialog = true
                        this.CurrentUser = User
                        this.MyCourseList = (response['data']['response'] || []).map(course => ({
                            ...course,
                            CanAccess: course.Disabled !== true
                        }))
                        console.log(this.MyCourseList)
                        return this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)

                    })
                    .then(response =>{
                        
                         this.$store.commit('SetCourseDetailList',response['data']['response'] || [])
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });
        },
        CloseDialog(){
            this.dialog = false
            this.CurrentUser  = {}
            this.MyCourseList = []
            this.CourseDialog = false
            this.MyCourseList   = []
            this.SelectedCourse = {}
            this.SelectCheckBox = ""
            this.checkbox         = false
            this.Schedules        = []
            this.CourseSchedules  = []
            this.SelectedSchedule = {}
        },
        UpdateUserDetails(){
    
            let data = { 'limit' : 10, 'page' : this.pages }
            data['User_Id'] = this.CurrentUser['_id']
            data['Update']  = {}
            data['Update']['Email']          = this.CurrentUser['Email']
            data['Update']['Name']           = this.CurrentUser['Name']
            data['Update']['Phone_Number']   = this.CurrentUser['Phone_Number']
            data['Update']['Qualification']  = this.CurrentUser['Qualification']
            data['Update']['Address']        = this.CurrentUser['Address']
            data['Update']['Referal_Code']   = this.CurrentUser['Referal_Code']
            data['Update']['Disable']        = this.CurrentUser['Disable']

            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/updateuserprofiles`,data)
                    .then(response => {
                        
                        this.Users = response['data']['response']
                        this.records = response['data']['Records']
                        this.CloseDialog()
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Successfully Updated User Details",Color: "green",Close: false});
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                    });
        }
    },
    mounted(){

        this.GetNextSetOfData({ 'limit' : 10, 'page' : this.pages })
    }
}
</script>
<style>
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsforCourses{
    width: 45.3%;
    margin: 10px;
    display: inline-block;
    -webkit-box-shadow: 0 0 6px 2px rgba(0,0,0,.16);
    box-shadow: 0 0 6px 2px rgba(0,0,0,.16);
    padding: 10px;
    text-align: center;
}

</style>
